import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'hmt-live-map-legend',
    templateUrl: './live-map-legend.component.html',
    styleUrls: ['./live-map-legend.component.scss'],
    standalone: false
})
export class LiveMapLegendComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
